import { z } from "zod";
import { Color } from "../shared/colors";
import { BaseOverlayConfig } from "../shared/config";
import { defineOverlay } from "../shared/functions";
const backgroundColors = [
    Color.DEFAULT_RED,
    Color.LIGHT_PURPLE,
    Color.DARK_PURPLE,
    Color.LIGHT_BLUE,
    Color.DARK_BLUE,
    Color.LIGHT_AQUA,
    Color.LIGHT_GREEN,
    Color.DARK_GREEN,
    Color.LIGHT_YELLOW,
    Color.DARK_YELLOW,
    Color.DARK_GREY,
];
export const GiftsThatGiveOverlay = defineOverlay({
    defaults: {
        amount: 0,
        backgroundColor: Color.DEFAULT_RED,
    },
    details: {
        category: "overlays",
        description: "Every dollar makes a difference. Enhance your fundraising experience by using our Gifts that Give overlay to show the impact your fundraising has for the patients and their families at St. Jude.",
        features: [
            "Automatically generates four Gifts that Give milestones based on your fundraising goal",
            "Easily see those you have completed",
            "Highlights top three donors",
            "Track the progress toward each milestone",
            "Custom colors fit any stream",
        ],
        flags: {
            isFeatured: true,
            isNew: false,
            isUpdated: false,
            isVisible: true,
        },
        icon: "overlays/gifts-that-give.png",
        name: "Gifts that Give Overlay",
        path: "/overlays/gifts-that-give",
        shortDescription: `Every dollar makes a difference. Show your fundraising impact on St. Jude`,
        slug: "gtg",
    },
    schema: BaseOverlayConfig.extend({
        amount: z
            .number()
            .int()
            .min(0)
            .default(() => GiftsThatGiveOverlay._config.defaults.amount)
            .optional(),
        backgroundColor: z
            .enum(backgroundColors)
            .default(() => GiftsThatGiveOverlay._config.defaults.backgroundColor)
            .optional(),
    }),
});
//# sourceMappingURL=gifts-that-give.js.map